export const getPaginationDataTotal = (total: number) => {
  if (total < 10) {
    return 1;
  }

  return Math.ceil(total / 10);
};
